"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.progress = void 0;

var _colors = _interopRequireDefault(require("../colors"));

var progress = {
  color: _colors["default"].primary.main,
  height: '3px'
};
exports.progress = progress;